import React from 'react'
import { InfoCircleOutlined } from '@ant-design/icons'
import { Button, Popover } from 'antd'
import { useTranslation } from 'react-i18next'

type ActionInfoProps = { name: string; children?: React.ReactNode }

export function ActionInfo({ name, children }: ActionInfoProps) {
    const { t } = useTranslation()
    if (!children) return null
    return (
        <Popover
            content={
                <div className="max-h-64 w-72 max-w-[calc(100vw-48px)] overflow-y-auto whitespace-pre-wrap break-words">
                    {children}
                </div>
            }
            trigger={['hover', 'focus']}
        >
            <Button
                className="shrink-0"
                type="text"
                size="small"
                icon={<InfoCircleOutlined />}
                aria-label={`${t('More information')}: ${name}`}
                onClick={(event) => event.stopPropagation()}
                onKeyDown={(event) => event.stopPropagation()}
            />
        </Popover>
    )
}
